module.exports = __webpack_public_path__ + "img/797.3f5505ca.jpg";